import { EFabricationOrderStatus } from '../fabrication-orders/types';
import { IFabricationProject } from '../fabrication-projects/types';

// Action Types
export enum Types {
  SAVE_FABRICATION_MOCKUP = 'mockups/SAVE_FABRICATION_MOCKUP',
  SAVE_FABRICATION_MOCKUP_SUCCESS = 'mockups/SAVE_FABRICATION_MOCKUP_SUCCESS',
  SAVE_FABRICATION_MOCKUP_FAILURE = 'mockups/SAVE_FABRICATION_MOCKUP_FAILURE',
  SET_EDITING_MOCKUP = 'mockups/SET_EDITING_MOCKUP',

  LOAD_FABRICATION_MOCKUPS = 'mockups/LOAD_FABRICATION_MOCKUPS',
  LOAD_FABRICATION_MOCKUPS_SUCCESS = 'mockups/LOAD_FABRICATION_MOCKUPS_SUCCESS',
  LOAD_FABRICATION_MOCKUPS_FAILURE = 'mockups/LOAD_FABRICATION_MOCKUPS_FAILURE',

  REMOVE_FABRICATION_MOCKUPS = 'mockups/REMOVE_FABRICATION_MOCKUPS',
  REMOVE_FABRICATION_MOCKUPS_SUCCESS = 'mockups/REMOVE_FABRICATION_MOCKUPS_SUCCESS',
  REMOVE_FABRICATION_MOCKUPS_FAILURE = 'mockups/REMOVE_FABRICATION_MOCKUPS_FAILURE',

  EDIT_PAVEMENT_STATUS = 'pavements/EDIT_PAVEMENT_STATUS',
  EDIT_PAVEMENT_STATUS_SUCCESS = 'pavements/EDIT_PAVEMENT_STATUS_SUCCESS',
  EDIT_PAVEMENT_STATUS_FAILURE = 'pavements/EDIT_PAVEMENT_STATUS_FAILURE'
}

export enum EMockupTab {
  MOCKUP = 'mockup',
  PROJECT = 'project'
}

export enum EPavementConcretingStatus {
  NOT_INITIALIZED = 'Não inicializado',
  WAITING_MATERIAL = 'Aguardando material',
  MATERIAL_AVAILABLE = 'Material disponível',
  DONE = 'Concluído'
}

export interface IFabricationMockup {
  id: number;
  name: string;
  createdAt: string;
  hasRoof: boolean;
  hasCovering: boolean;
  typicalFloorPlan: string;
  otherTypicalFloorPlan: string;
  updatedAt: string;

  pavements: IPavement[];
}

export interface IPavement extends Omit<IPavementData, 'id'> {
  id?: number | string;
  name: string;
  updatedAt?: string;
  position: number;
  isNewPavement?: boolean;
  slabDate?: string;
  slabStatus?: EPavementConcretingStatus;
  beamDate?: string;
  beamStatus?: EPavementConcretingStatus;
  pillarDate?: string;
  pillarStatus?: EPavementConcretingStatus;

  orders?: IPavementOrder[];
  projects?: IFabricationMockupProject[];
}

export type IFabricationMockupProject = Omit<
  IFabricationProject,
  | 'contractNumber'
  | 'hasOrders'
  | 'pavements'
  | 'revisionStatus'
  | 'mockupId'
  | 'mockupName'
>;

export interface IPavementData {
  id: number;
  name: string;
  position: number;
}

export interface IPavementOrder {
  id: number;
  orderNumber: string;
  orderStatus: EFabricationOrderStatus;
  sendDate: string;
  totalWeight: number;
}

export interface IFabricationMockupsState {
  mockups: IFabricationMockup[];
  pavements?: IPavement;
  contractNumber?: string;
  loading: boolean;
  error: boolean;

  saveMockupState: {
    editingMockupId?: number;
    loading: boolean;
    error: boolean;
    success: boolean;
  };

  removeMockupState?: {
    loading: boolean;
    error: boolean;
  };

  editPavementState?: {
    editingPavementId?: number | string;
    loading: boolean;
    error: boolean;
    success: boolean;
  };
}
